import { memo, useEffect, useState } from "react";

const UpdateAvailablePrompt = ({ show, onReload }) => {
    const [dismissed, setDismissed] = useState(false);

    useEffect(() => {
        if (show) setDismissed(false);
    }, [show]);

    const handleCancel = () => {
        setDismissed(true);
    };

    const handleReload = () => {
        onReload();
    };

    if (!show || dismissed) return null;

    return (
        <div className="strNtf updNtf">
            <button className="btn strNtfCls" onClick={handleCancel}>
                <span className="crIcs v2">
                    <img className="img-fluid"
                        src={require("../../../assets/images/inner/circle-outer.svg").default} alt="circle-outer"
                        width={60} />
                    <img className="img-fluid"
                        src={require("../../../assets/images/inner/circle-inner.svg").default} alt="circle-inner"
                        width={60} />
                    <span className="crIc">
                        <img src={require("../../../assets/icons/close.svg").default} alt="close" />
                    </span>
                </span>
            </button>
            <div className="shps">
                <div className="prfRvnBg1"></div>
                <div className="prfRvnBg2"></div>
                <div className="prfRvnSh5"></div>
                <div className="prfRvnSh6"></div>
                <div className="prfRvnSh1"></div>
                <div className="prfRvnSh2"></div>
                <div className="prfRvnSh3"></div>
                <div className="prfRvnSh4">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
            </div>
            <div className="strNtfHd">A new version is available</div>
            <div className="ratUsSbm">
                <button
                    type="button"
                    className="btn btnShp2 btn-11552"
                    onClick={handleCancel}
                >
                    <span className="btnShp2Ln1"></span>
                    <span className="btnShp2Ln2"></span>
                    <span className="btnShp2Ln3"></span>
                    <span className="btnShp2Bg"></span>
                    <span className="btnShp2Br"></span>
                    <span className="btnShp2Tx">Later</span>
                </button>
                <button
                    type="button"
                    className="btn btnShp2 btn-11552"
                    onClick={handleReload}
                >
                    <span className="btnShp2Ln1"></span>
                    <span className="btnShp2Ln2"></span>
                    <span className="btnShp2Ln3"></span>
                    <span className="btnShp2Bg"></span>
                    <span className="btnShp2Br"></span>
                    <span className="btnShp2Tx">Refresh now</span>
                </button>
            </div>

        </div>
    );
};

export default memo(UpdateAvailablePrompt);